/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Select, Pagination } from 'antd';
import { useDebounce } from 'use-debounce';
import '../Users/style.scss'; // Shared filter styles
import './style.scss';
import { AdminApi } from '../../api/Admin';
import LoadingTable from '../../components/LoadingTable';
import { formatTimestamp, formatNumber, truncateText } from '../Utils';
import { Noti } from '../../components/Noti/toast';
import { TransactionStatusEnum } from '../../components/constants/TransactionStatusEnum';


const TransactionsPage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState<any>('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState<any[]>([]);
    const [debouncedSearchTerm] = useDebounce(searchTerm, 300);

    // Reset về trang 1 khi filter thay đổi
    React.useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearchTerm, statusFilter]);

    const getTxnStatusClass = (status: any) => {
        switch (status) {
            case TransactionStatusEnum.COMPLETED: return 'status-completed';
            case TransactionStatusEnum.CANCELLED: return 'status-failed';
            case TransactionStatusEnum.DEBITED: return 'status-pending';
            case TransactionStatusEnum.FAILED: return 'status-failed';
            case TransactionStatusEnum.AWAITING_SETTLEMENT: return 'status-awaiting';
            case TransactionStatusEnum.SCAN_QR_CODE: return 'status-pending';
            case TransactionStatusEnum.ALLOW_RETRY_SETTLEMENT: return 'status-pending';
            default: return '';
        }
    };

    const getStatusLabel = (status: string) => {
        switch (status) {
            case TransactionStatusEnum.SCAN_QR_CODE: return 'Scan QR Code';
            case TransactionStatusEnum.DEBITED: return 'Debited';
            case TransactionStatusEnum.AWAITING_SETTLEMENT: return 'Awaiting Settlement';
            case TransactionStatusEnum.COMPLETED: return 'Completed';
            case TransactionStatusEnum.FAILED: return 'Failed';
            case TransactionStatusEnum.CANCELLED: return 'Cancelled';
            case TransactionStatusEnum.ALLOW_RETRY_SETTLEMENT: return 'Allow Retry Settlement';
            default: return status;
        }
    };



    async function handleCopy(id: any) {
        try {
            await navigator.clipboard.writeText(id);
            Noti('success', `Copied`, 3000)
        } catch (err) {
            Noti('error', `Failed to copy!`, 3000)
        }
    }

    const getListTransactions = async () => {
        setLoading(true);
        try {
            let params = {
                search: debouncedSearchTerm,
                status: statusFilter,
                page: currentPage,
                limit: pageSize,
            };
            const res = await AdminApi.GetListTransactions(params);
            if (res?.data?.success) {
                setTransactions(res?.data?.data);
                setTotalItems(res?.data?.meta?.totalItems);
            } else {
                setTransactions([]);
                setTotalItems(0);
            }
        } catch (err: any) {
            setTransactions([]);
            setTotalItems(0);
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getListTransactions();
    }, [currentPage, debouncedSearchTerm, statusFilter]);

    return (
        <div className="page active">
            <h1 className="transactions-page-title">Transaction Log</h1>
            <div className="content-card">
                <div className="transactions-filters">
                    <input
                        type="search"
                        placeholder="Search by Txn ID or User ID..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        className="form-input search-input"
                    />
                    <div className="status-filter">
                        <label htmlFor="txn-status-filter">Status:</label>
                        <Select
                            id="txn-status-filter"
                            value={statusFilter}
                            onChange={(value) => setStatusFilter(value)}
                            className="status-select"
                            style={{ width: '100%' }}
                            options={[
                                { value: '', label: 'All' },
                                { value: TransactionStatusEnum.SCAN_QR_CODE, label: 'Scan QR Code' },
                                { value: TransactionStatusEnum.DEBITED, label: 'Debited' },
                                { value: TransactionStatusEnum.AWAITING_SETTLEMENT, label: 'Awaiting Settlement' },
                                { value: TransactionStatusEnum.COMPLETED, label: 'Completed' },
                                { value: TransactionStatusEnum.FAILED, label: 'Failed' },
                                { value: TransactionStatusEnum.CANCELLED, label: 'Cancelled' },
                                { value: TransactionStatusEnum.ALLOW_RETRY_SETTLEMENT, label: 'Allow Retry Settlement' },
                            ]}
                        />
                    </div>
                </div>
                <div className="table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Timestamp (UTC)</th>
                                <th>PWC Txn ID</th>
                                <th>User ID</th>
                                <th>Amount (RUB)</th>
                                <th>Amount (Fiat)</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? <tr>
                                <td colSpan={6}>
                                    <div className="box-nodata">
                                        <LoadingTable />
                                    </div>
                                </td>
                            </tr> : <>
                                {transactions.length > 0 ? transactions.map((txn: any, index: any) => (
                                    <tr key={txn.id}>
                                        <td data-label="Timestamp">{formatTimestamp(txn.createdAt)}</td>
                                        <td data-label="PWC Txn ID">
                                            {txn.id ? (
                                                <div className='row-copy'>
                                                    <span>{truncateText(txn.id)}</span>
                                                    <img
                                                        onClick={() => handleCopy(txn.id)}
                                                        className='icon-copy'
                                                        src="/images/copy.png"
                                                        alt=""
                                                    />
                                                </div>
                                            ) : ('N/A')}
                                        </td>
                                        <td data-label="User ID">
                                            {txn.internal_user_id ? (
                                                <div className='row-copy'>
                                                    <span>{truncateText(txn.internal_user_id)}</span>
                                                    <img
                                                        onClick={() => handleCopy(txn.internal_user_id)}
                                                        className='icon-copy'
                                                        src="/images/copy.png"
                                                        alt=""
                                                    />
                                                </div>
                                            ) : ('N/A')}
                                        </td>
                                        <td data-label="Amount (RUB)">{formatNumber(txn.totalRubUserPays, 2) || 'N/A'}</td>
                                        <td data-label="Amount (Fiat)">
                                            {formatNumber(txn.fiat_amount, 2) || 'N/A'} {' '}
                                            {txn.fiat_currency && txn.fiat_amount ? `${txn.fiat_currency}` : ''}
                                        </td>
                                        <td data-label="Status">
                                            <span
                                                className={`status-badge ${getTxnStatusClass(txn.status)}`}
                                            >
                                                {getStatusLabel(txn.status)}
                                            </span>
                                        </td>
                                    </tr>
                                )) : <tr><td colSpan={6} className="no-data">No transactions found.</td></tr>}
                            </>}
                        </tbody>
                    </table>
                </div>
                {transactions.length > 0 && (
                    <div className="pagination-wrapper">
                        <Pagination
                            current={currentPage}
                            pageSize={pageSize}
                            total={totalItems}
                            // showSizeChanger
                            // showQuickJumper
                            // showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} transactions`}
                            onChange={(page, size) => {
                                setCurrentPage(page);
                                // setPageSize(size);
                            }}
                        // onShowSizeChange={(current, size) => {
                        //     setCurrentPage(1);
                        //     setPageSize(size);
                        // }}
                        // pageSizeOptions={['5', '10', '20', '50', '100']}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default TransactionsPage;